import { render, staticRenderFns } from "./ModalFormularioProgramaUniversidadV2.vue?vue&type=template&id=678330a8&scoped=true"
import script from "./ModalFormularioProgramaUniversidadV2.vue?vue&type=script&lang=js"
export * from "./ModalFormularioProgramaUniversidadV2.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioProgramaUniversidadV2.vue?vue&type=style&index=0&id=678330a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678330a8",
  null
  
)

export default component.exports